import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

export default function Layout() {
  const { user, logout } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();

  if (!user) {
    return <Outlet />;
  }

  const navItems = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/events', label: 'Events' },
    { path: '/test', label: 'Test Event' },
    { path: '/widget-preview', label: 'Widget Preview' },
    { path: '/settings', label: 'Settings' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-layout">
      <header className="app-header">
        <div className="header-content">
          <Link to="/dashboard" className="logo">
            💜 Donate System
          </Link>
          <nav className="header-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="header-actions">
            <span className="username">{user.username}</span>
            <button onClick={handleLogout} className="btn-logout">
              Logout
            </button>
          </div>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <style>{`
        .app-layout {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        .app-header {
          background: var(--bg-card);
          border-bottom: 1px solid var(--border);
          padding: 0 20px;
          position: sticky;
          top: 0;
          z-index: 100;
        }
        .header-content {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          gap: 30px;
          height: 60px;
        }
        .logo {
          font-size: 20px;
          font-weight: 700;
          color: var(--text-primary);
          text-decoration: none;
        }
        .header-nav {
          display: flex;
          gap: 5px;
          flex: 1;
        }
        .nav-link {
          padding: 8px 16px;
          border-radius: 6px;
          color: var(--text-secondary);
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s;
        }
        .nav-link:hover {
          color: var(--text-primary);
          background: var(--bg-input);
        }
        .nav-link.active {
          color: var(--primary);
          background: rgba(145, 71, 255, 0.1);
        }
        .header-actions {
          display: flex;
          align-items: center;
          gap: 15px;
        }
        .username {
          font-size: 14px;
          color: var(--text-secondary);
        }
        .btn-logout {
          padding: 8px 16px;
          background: transparent;
          border: 1px solid var(--border);
          border-radius: 6px;
          color: var(--text-secondary);
          font-size: 13px;
          transition: all 0.2s;
        }
        .btn-logout:hover {
          border-color: var(--error);
          color: var(--error);
        }
        .app-main {
          flex: 1;
          padding: 30px 20px;
        }
        @media (max-width: 768px) {
          .header-content {
            flex-wrap: wrap;
            height: auto;
            padding: 10px 0;
            gap: 10px;
          }
          .header-nav {
            order: 3;
            width: 100%;
            overflow-x: auto;
          }
        }
      `}</style>
    </div>
  );
}
